import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgUnlocked = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M22.67 9.33h-12v-4A5.34 5.34 0 0 0 0 5.33c0 1 1.33 1.13 1.33 0a4 4 0 0 1 8 0v4h-4A1.28 1.28 0 0 0 4 10.56v12.1a1.19 1.19 0 0 0 1 1.33 1.3 1.3 0 0 0 .28 0h17.39A1.29 1.29 0 0 0 24 22.74V10.66a2.05 2.05 0 0 0-1.33-1.33m-8 8.41 1 3.13h-3.43l1-3.14h.09a2.66 2.66 0 1 1 1.35 0Z"
    }));
export default SvgUnlocked;
